function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Divider, Drawer, List, ListItem, ListItemIcon, ListItemText, ListSubheader, Toolbar, Typography, Link as MaterialLink, Collapse, Grid } from "@mui/material";
export var DEFAULT_DRAWER_WIDTH = 240;
export default function Navigation(param) {
    var _param_drawerWidth = param.drawerWidth, drawerWidth = _param_drawerWidth === void 0 ? DEFAULT_DRAWER_WIDTH : _param_drawerWidth, items = param.items, serviceTitle = param.serviceTitle, Link = param.Link;
    var _React_useState = _sliced_to_array(React.useState([]), 2), openedListIndexes = _React_useState[0], setOpenedListIndexes = _React_useState[1];
    var isListExpanded = function(index) {
        return openedListIndexes.includes(index);
    };
    var handleToggleList = function(index) {
        if (isListExpanded(index)) {
            setOpenedListIndexes(function(prev) {
                return prev.filter(function(listIndex) {
                    return listIndex !== index;
                });
            });
        } else {
            setOpenedListIndexes(function(prev) {
                return _to_consumable_array(prev).concat([
                    index
                ]);
            });
        }
    };
    return /*#__PURE__*/ _jsxs(Drawer, {
        variant: "permanent",
        anchor: "left",
        css: {
            flexShrink: 0,
            width: drawerWidth,
            ".MuiDrawer-paper": {
                width: drawerWidth
            }
        },
        children: [
            /*#__PURE__*/ _jsx(Toolbar, {
                children: /*#__PURE__*/ _jsx(Link, {
                    href: "/",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        color: "textSecondary",
                        variant: "h6",
                        css: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ _jsx(MaterialLink, {
                            color: "inherit",
                            children: serviceTitle
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsx(List, {
                children: items.map(function(item, i) {
                    var isExpanded = isListExpanded(i);
                    return /*#__PURE__*/ _jsx(Fragment, {
                        children: item.type !== "group" ? /*#__PURE__*/ _jsx(NavigationListItem, {
                            item: item,
                            Link: Link
                        }) : /*#__PURE__*/ _jsx(List, {
                            subheader: /*#__PURE__*/ _jsxs(Grid, {
                                container: true,
                                alignItems: "center",
                                justifyContent: "space-between",
                                css: {
                                    cursor: "pointer",
                                    paddingRight: "1em"
                                },
                                onClick: function() {
                                    return handleToggleList(i);
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        children: /*#__PURE__*/ _jsx(ListSubheader, {
                                            children: item.text
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Grid, {
                                        item: true,
                                        children: isExpanded ? /*#__PURE__*/ _jsx(ExpandLessIcon, {
                                            color: "action"
                                        }) : /*#__PURE__*/ _jsx(ExpandMoreIcon, {
                                            color: "action"
                                        })
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ _jsx(Collapse, {
                                in: isExpanded,
                                children: item.children.map(function(childItem, i) {
                                    return /*#__PURE__*/ _jsx(NavigationListItem, {
                                        item: childItem,
                                        Link: Link
                                    }, i);
                                })
                            })
                        })
                    }, i);
                })
            })
        ]
    });
}
function NavigationListItem(param) {
    var _param_item = param.item, icon = _param_item.icon, text = _param_item.text, to = _param_item.to, Link = param.Link;
    var pathname = window.location.pathname;
    return /*#__PURE__*/ _jsx(Link, {
        href: to,
        children: /*#__PURE__*/ _jsxs(ListItem, {
            button: true,
            selected: pathname.startsWith(to),
            children: [
                icon && /*#__PURE__*/ _jsx(ListItemIcon, {
                    children: icon
                }),
                /*#__PURE__*/ _jsx(ListItemText, {
                    children: text
                })
            ]
        })
    });
}
